import { ReactNode } from 'react';

import { ICurbsideConfirmationModalProps } from '../top-service-mode/curbside-confirmation-modal/curbside-confirmation-modal';

export interface ITopServiceModeProps {}

export interface ITopServiceModeViewProps {
  heading: string;
  details: ReactNode;
  icon: ReactNode;
  onTopServiceClick?: () => void;
  variant?: TopServiceVariants;
  className?: string;
  isLoading?: boolean;
  reversed?: boolean;
}

export type ITopServiceModeWithFutureOrderingViewProps = ITopServiceModeViewProps & {
  futureOrderDate?: string | null;
};

export interface ITopServiceModeDetail {
  heading: string;
  details: ReactNode;
  icon: ReactNode;
  onTopServiceClick?: () => void;
  variant?: TopServiceVariants;
  CurbsideConfirmationModal: React.FC<React.PropsWithChildren<ICurbsideConfirmationModalProps>>;
  curbsideConfirmationModalOpen: boolean;
  setCurbsideConfirmationModalOpen: React.Dispatch<any>;
  refetchUserOrder: () => void;
  futureOrderDate?: string | null;
}

export enum TopServiceVariants {
  DEFAULT = 'DEFAULT',
  IN_PROGRESS = 'IN_PROGRESS',
  NO_STORE = 'NO_STORE',
  IN_RESTAURANT_LOYALTY = 'IN_RESTAURANT_LOYALTY',
}
